define([
	"dojo/_base/declare",
	"csi/datasheet/Widget",
	"csi/def",
	"csi/reflection",
	"csi/xml"
], function(declare,DataSheetWidget,def,reflection,xml) {

	return declare(DataSheetWidget, {
		_resolveView: function() {
			// summary: assign appropriate target type to ProductProperties and ProductColors views based on ProductType
			var	node = this.getViewNode();
			if (node) {
				var	type = xml.enumGetText(node.TemplateType);
				var	rc = reflection.getClass(type);
				var typeSourcing = type + "Sourcing";
				var rcSourcing = reflection.getClass(typeSourcing);

				this.prefKey = def.composeViewKey("CoverSheet","DataPackage",type);
				this.defView.defsByKey.ProductColors.rcTarget = rc;
				this.defView.defsByKey.ProductColorGallery.rcTarget = rc;
				this.defView.defsByKey.ProductSKU.rcTarget = rc;
				this.defView.defsByKey.ProductSKUGallery.rcTarget = rc;
				this.defView.defsByKey.ProductSamples.rcTarget = rc;
				this.defView.defsByKey.ProductSamplesGallery.rcTarget = rc;
				this.defView.defsByKey.SupplierItems.rcTarget = rcSourcing;
				this.defView.defsByKey.SupplierItemsGallery.rcTarget = rcSourcing;

				this.defView.defsByKey.ProductProperties.rcTarget = rc;

				if (type == "Material") {
					delete this.defView.defsByKey.Assortment; // doesn't apply
				}
			}

			this.inherited(arguments);
		}
	});
});